// extracted by mini-css-extract-plugin
export default {"container":"CustomCheckbox_container__V+C9J","checkmark":"CustomCheckbox_checkmark__W1QLm"};